/*
 * Copyright (C) 2022 to Present Applause App Quality, Inc. All rights reserved.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MessagePanelComponent } from './message-panel.component';

@NgModule({
  declarations: [
    MessagePanelComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
  ],
  exports: [
    MessagePanelComponent,
  ]
})
export class MessagePanelModule {}
